import { useContext, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import services from '@/services/services'

const useLabelTrackingInfo = ({ trackingId }) => {
  const { setContext } = useContext(AppContext)
  const { data, loading } = useFetch(() => services.getTrackingInfo({ trackingId }), {
    doInitialRequest: true,
  })

  useEffect(() => {
    if (data) {
      setContext(context => ({
        ...context,
        merchantInfo: { ...context.merchantInfo, theme: data.portal?.theme },
        orderInfo: { orderNumber: data.order_name },
      }))
    }
  }, [data, setContext])

  return {
    trackingInfo: data,
    fetchingTrackingInfo: loading,
  }
}

export default useLabelTrackingInfo
